import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';
import Cookies from 'js-cookie';

export default function Admin() {


   /* return (!(rol === "Admin") ? window.location.href = "/account/loginAdmin" : <Navigate to="/usuarios" />);*/
    window.location.href = "/usuarios"

}
